import { Link } from "react-router-dom";

/**
 * EmptyState — editorial, no-emoji empty state used on list pages.
 *
 * Props:
 *   icon       react node (phosphor icon, ~28px)
 *   title      short heading
 *   body       optional secondary line
 *   action     optional { label, to } — renders a link-styled CTA
 *   testid     data-testid
 */
export default function EmptyState({ icon, title, body, action, testid = "empty-state" }) {
  return (
    <div
      data-testid={testid}
      className="col-span-full border border-zinc-200 bg-[#FAFAFA] px-6 py-14 md:py-20 flex flex-col items-center text-center"
    >
      {icon && (
        <div className="w-12 h-12 rounded-full bg-white border border-zinc-200 flex items-center justify-center text-zinc-400 mb-5">
          {icon}
        </div>
      )}
      <div className="font-display font-bold text-2xl md:text-3xl tracking-tight text-zinc-950 mb-2">
        {title}
      </div>
      {body && (
        <p className="text-sm text-zinc-500 max-w-md leading-relaxed">
          {body}
        </p>
      )}
      {action && (
        <Link
          to={action.to}
          data-testid={`${testid}-cta`}
          className="btn-secondary mt-6"
          style={{ padding: ".55rem 1.1rem" }}
        >
          {action.label}
        </Link>
      )}
    </div>
  );
}
